import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { extractSignersFromList } from "utils/signatureUtils";

interface UseSignerSelectionParams {
  signTypeProps?: string;
  managerSigner?: string;
  assignedUserId?: string;
  isEditMode: boolean;
}

export function useSignerSelection({
  signTypeProps,
  managerSigner,
  assignedUserId,
  isEditMode,
}: UseSignerSelectionParams) {
  const { t } = useTranslation();
  const [selectedUser, setSelectedUser] = useState(managerSigner || "");
  const [selectedContactIds, setSelectedContactIds] = useState<string[]>([]);
  const [signType, setSignType] = useState("Dokobit");
  const [selectedNonTechUser, setSelectedNonTechUser] = useState<any>(
    assignedUserId || ""
  );
  const [selectedTabUser, setSelectedTabUser] = useState<string>("");

  const signCollection = [
    { label: t("manual_sign"), value: "Manual" },
    { label: "Dokobit", value: "Dokobit" },
    { label: "Signontab", value: "Signontab" },
  ];

  const handleSignType = (value: string) => {
    setSignType(value);
  };

  useEffect(() => {
    if (signTypeProps) setSignType(signTypeProps);
  }, [signTypeProps]);

  useEffect(() => {
    if (!isEditMode && managerSigner && !selectedUser) {
      setSelectedUser(managerSigner);
    }
  }, [isEditMode, managerSigner]);

  const hydrateSigners = (signersList: any) => {
    const extracted = extractSignersFromList(signersList);
    if (extracted.contactSigners?.length) {
      setSelectedContactIds(
        extracted.contactSigners
          .map((signer: any) => signer?.id ?? signer ?? "")
          .filter(Boolean)
      );
    }
    if (extracted.permissionUserSigner?.id)
      setSelectedUser(extracted.permissionUserSigner.id);
    if (extracted.nonTechUserSigner?.id)
      setSelectedNonTechUser(extracted.nonTechUserSigner.id);
  };

  return {
    selectedUser,
    setSelectedUser,
    selectedContactIds,
    setSelectedContactIds,
    signType,
    setSignType,
    selectedNonTechUser,
    setSelectedNonTechUser,
    selectedTabUser,
    setSelectedTabUser,
    signCollection,
    handleSignType,
    hydrateSigners,
  };
}
